import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const printProductionLabel = createAsyncThunk('printer/printProductionLabel',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await authGet(`/printer/print/product_lbl/${id}`);
    } catch (error) {
      return rejectWithValue(`${error?.message} ${error?.info || ''}`);
    }
  });

export default printProductionLabel;
